module.exports = __webpack_public_path__ + "assets/img/chef-10.b5431703.jpg";